<div class="tour-list" [dir]="layoutService?.websiteDirection$ | async">
  <header class="p-4 mb-5 tour-list__header bg-primary text-white pos-relative">
    <section>
      <app-icon 
        class="cursor-pointer mr-3 text-white rotate-180" 
        name="right-arrow" 
        size="xs"
        mat-dialog-close>
      </app-icon>
      <span class="small">{{ 'shared.GuidedTour' | translate }}</span>
    </section>
    
    <div class="tour-list__counter pos-absolute p-1 bg-white radius-50">
      <div class="tour-list__counter--circle p-1 w-100 h-100 radius-50">
        <mat-progress-spinner 
          mode="determinate" 
          [value]="(counters$ | async).percentage" 
          diameter="60" 
          strokeWidth="9" 
          color="primary"></mat-progress-spinner>
        <div class="pos-absolute pos-center mb-0 h6 text-700">{{(counters$ | async).visited + '/' + (counters$ | async).total}}</div>
      </div>
    </div>
  </header>

  <main class="p-4 pb-2 pt-4 scrollable scrollable--y tour-list">
    <app-state-section [state]="sectionState">
      <ng-container *ngFor="let tour of toursList$ | async; let last=last">
        <div
          class="mb-3">
          <div class="flex align-start justify-space-between mb-3">
            <div class="col-9 flex">
              <app-icon class="mr-3 mb-1" name="outline-tick-circle" size="sm" [ngClass]="{'text-300': !tour.isVisited, 'text-success': tour.isVisited }"></app-icon>
              <div class="flex column">
                <div class="small m-0 text-900 text-ellipsis-1">{{ tour?.title }}</div>
                <div class="small m-0 text-500 text-ellipsis-2">{{ tour?.description }}</div>
              </div>
            </div>
  
            <div 
              mat-dialog-close
              class="small text-primary-200 cursor-pointer" 
              style="height: 2px;"
              (click)="startTour(tour)"
              >
              {{ (tour.isVisited ? 'shared.ReplayTour' : 'shared.GetStarted') | translate }}
            </div>
          </div>
          <mat-divider *ngIf="!last" class="text-300"></mat-divider>
        </div>
      </ng-container>
    </app-state-section>
  </main>
</div>

